import { UIText2 } from '@cian/ui-kit';

import { IFilterProps } from '../../types';
import * as styles from './styles.css';
import { FC, PropsWithChildren } from 'react';

export const Filter: FC<PropsWithChildren<IFilterProps>> = ({ children, title, dataName }) => {
  return (
    <div className={styles['filter']} data-name={dataName}>
      <div className={styles['title']}>
        <UIText2>{title}</UIText2>
      </div>
      <div className={styles['wrapper']}>
        <div className={styles['scrollable']}>{children}</div>
      </div>
    </div>
  );
};
